import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from "@angular/router";

@Component({
  selector: 'app-component-subnav',
  standalone: true,
  imports: [
    RouterLinkActive,
    RouterLink
  ],
  templateUrl: './component-subnav.component.html',
  styleUrl: './component-subnav.component.sass'
})
export class ComponentSubnavComponent {

}
